(() => {
  function init(root){
    // ---------- Constants & Elements ----------
    const STEP = parseInt(root.dataset.step,10) || 1;
    const MIN  = parseInt(root.dataset.min,10)  || 0;

    const totalEl   = root.querySelector('#qovg-total');
    const totalItemsEl = root.querySelector('#qovg-total-items');
    const errorEl   = root.querySelector('#qovg-error');
    const addBtn    = root.querySelector('#qovg-add');
    const buyNowBtn = root.querySelector('#qovg-buy-now');
    const allQtyInputs = Array.from(root.querySelectorAll('.qovg__qty')); // listeners bind to all; active set used for math

    const subtotalEl      = root.querySelector('#qovg-subtotal');
    const subtotalRawEl   = root.querySelector('#qovg-subtotal-raw');
    const discountItemsEl = root.querySelector('#qovg-discount-items');
    const discountDecoEl  = root.querySelector('#qovg-discount-deco');
    // Visual / logic toggles (all default to true)
    const SHOW_ITEM_DISCOUNTS  = root.getAttribute('data-show-item-discounts')  !== 'false';
    const SHOW_DECO_DISCOUNTS  = root.getAttribute('data-show-deco-discounts')  !== 'false';
    const ENABLE_DECO_DISCOUNT = root.getAttribute('data-enable-deco-discount') !== 'false';
    // ---------- Globo helpers ----------
    // Update a GPO hidden/text field so GPO conditions can read our totals
    function gpoSetField(field, value) {
      const str = String(value);

      // Hidden mirror (the one GPO actually submits/reads from)
      let mirror = document.querySelector(`.gpo-hidden-inputs input[name="properties[${field}]"]`)
                || document.querySelector(`.gpo-hidden-inputs input[data-field-name="${field}"]`);
      if (mirror) {
        mirror.value = str;
        mirror.setAttribute('data-value', str);
        mirror.removeAttribute('disabled');
        ['input','change','keyup'].forEach(evt =>
          mirror.dispatchEvent(new Event(evt, { bubbles:true }))
        );
      }

      // If a visible control exists for the same field, keep it in sync too
      const visNodes = document.querySelectorAll(
        `.gpo-element[data-field-name="${field}"] input, input[name="${field}"]`
      );
      visNodes.forEach(vis => {
        vis.value = str;
        vis.removeAttribute('disabled');
        vis.setAttribute('readonly','readonly'); // prevent customer edits
        ['input','change','keyup'].forEach(evt =>
          vis.dispatchEvent(new Event(evt, { bubbles:true }))
        );
      });

      // Give GPO a nudge to re-evaluate rules/UI
      document.dispatchEvent(new CustomEvent('gpo:fieldChanged', { detail:{ field, value:str } }));
      window.dispatchEvent(new Event('resize'));
    }

      function getProductForm(){
      return document.querySelector('form[action^="/cart/add"]');
    }

    // Read the currently selected variant from the main product form
    function getActiveVariantIdFromMainForm(){
      const form = getProductForm();
      if (!form) return null;

      // 1) <select name="id">
      const sel = form.querySelector('select[name="id"]');
      if (sel && sel.value) return sel.value;

      // 2) <input type="radio" name="id">
      const radio = form.querySelector('input[name="id"]:checked');
      if (radio && radio.value) return radio.value;

      // 3) hidden <input name="id">
      const hidden = form.querySelector('input[name="id"][type="hidden"]');
      if (hidden && hidden.value) return hidden.value;

      return null;
    }

    // Given a variant id, find which card/colour group it belongs to
    function getGroupValueForVariant(root, variantId){
      if (!variantId) return null;
      const row  = root.querySelector('tr[data-variant-id="' + variantId + '"]');
      if (!row) return null;
      const card = row.closest('.qovg__card');
      if (!card) return null;
      return card.getAttribute('data-group') || null;
    }


    function ensureProxyQuantityInput(){
      const form = getProductForm();
      if (!form) return null;
      let qty = form.querySelector('input[name="quantity"]');
      if (!qty) {
        qty = document.createElement('input');
        qty.type = 'number';
        qty.name = 'quantity';
        qty.value = '0';
        qty.min = '0';
        qty.id = 'qovg-proxy-qty';
        qty.style.position = 'absolute';
        qty.style.left = '-9999px';
        qty.setAttribute('aria-hidden', 'true');
        form.appendChild(qty);
      }
      return qty;
    }

    function pokeGPOQuantityEvents(el){
      if (!el) return;
      el.dispatchEvent(new Event('input',  { bubbles:true }));
      el.dispatchEvent(new Event('change', { bubbles:true }));
      el.dispatchEvent(new Event('keyup',  { bubbles:true }));
      document.dispatchEvent(new CustomEvent('gpo:quantityChanged', { detail:{ quantity: parseInt(el.value||'0',10) } }));
      window.dispatchEvent(new Event('resize'));
    }

    function mountGloboNextToGrid(){
      const mount = root.querySelector('#qovg-gpo-mount');
      if (!mount) return;

      const candidates = [
        '[data-gpo-root]','#gpo-root','.gpo-widget','.globo-options','.gpo-container','[data-gpo-container]'
      ];
      let gpo = null;
      for (const sel of candidates){
        gpo = document.querySelector(sel);
        if (gpo) break;
      }
      if (!gpo) return;
      if (mount.contains(gpo)) return;

      mount.innerHTML = '';
      mount.appendChild(gpo);
    }

    function waitAndMountGPO(){
      mountGloboNextToGrid();
      let tries = 0;
      const i = setInterval(()=>{
        tries++; mountGloboNextToGrid();
        if (tries > 10) clearInterval(i);
      }, 300);
      const obs = new MutationObserver(()=> mountGloboNextToGrid());
      obs.observe(document.documentElement, { childList:true, subtree:true });
      setTimeout(()=>obs.disconnect(), 10000);
    }

    function collectGPOAddonVariants() {
      const nodes = document.querySelectorAll(
        '.gpo-ov-wrapper input:checked[gpo-data-variant-id], .gpo-ov-wrapper option:checked[gpo-data-variant-id]'
      );
      return Array.from(nodes).map(el => ({
        id: Number(el.getAttribute('gpo-data-variant-id')),
        quantity: Number(el.getAttribute('data-quantity')) || 1
      })).filter(x => x.id);
    }

    // ---------- Active row/input helpers ----------
    function getActiveInputs(){
      return Array.from(root.querySelectorAll('.qovg__card:not(.is-hidden) .qovg__qty'));
    }
    function getActiveRows(){
      return Array.from(root.querySelectorAll('.qovg__card:not(.is-hidden) tr[data-variant-id]'));
    }

    // ---------- Money/discount helpers ----------
    function money(cents){
      if (window.Shopify && Shopify.formatMoney) {
        try { return Shopify.formatMoney(cents, Shopify.money_format || "${{amount}}"); } catch(e){}
      }
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return (cents/100).toLocaleString(undefined, {style:'currency',currency});
    }

    function parseDiscounts(){
      const raw = root.getAttribute('data-discounts') || '';
      if(!raw) return [];
      return raw.split(';').map(s=>s.trim()).filter(Boolean).map(s=>{
        const [min,type,value] = s.split('|');
        return { min: parseInt(min,10)||0, type: (type||'percent').toLowerCase(), value: parseFloat(value||'0') };
      }).sort((a,b)=> a.min - b.min);
    }
    const DISCOUNTS = parseDiscounts();

    function currentDiscount(qty){
      let found = null;
      for(const t of DISCOUNTS){ if(qty >= t.min){ found = t; } else { break; } }
      return found;
    }

    function parseDecoDiscounts(){
      const raw = root.getAttribute('data-deco-discounts') || '';
      if(!raw) return [];
      return raw.split(';').map(s=>s.trim()).filter(Boolean).map(s=>{
        const [min,type,value] = s.split('|');
        return { min: parseInt(min,10)||0, type: (type||'percent').toLowerCase(), value: parseFloat(value||'0') };
      }).sort((a,b)=> a.min - b.min);
    }
    const DECO_DISCOUNTS = parseDecoDiscounts();

    function currentDecoDiscount(qty){
      let found = null;
      for(const t of DECO_DISCOUNTS){
        if(qty >= t.min){ found = t; } else { break; }
      }
      return found;
    }

    const formatInt = v => Math.max(0, parseInt(v || '0',10) || 0);

    // ---------- Math/UI sync ----------
    function rowTotals(){
      const cards = Array.from(root.querySelectorAll('.qovg__card'));
      cards.forEach(card=>{
        const inputs = Array.from(card.querySelectorAll('.qovg__qty'));
        const sum = inputs.reduce((a,i)=> a + formatInt(i.value), 0);
        const target = card.querySelector('[data-row-total]');
        if(target) target.textContent = sum;
      });
    }

    function grandTotal(){
      return getActiveInputs().reduce((a,i)=> a + formatInt(i.value), 0);
    }

    function computeSubtotalCents(){
      return getActiveRows().reduce((sum, tr)=>{
        const price = parseInt(tr.getAttribute('data-price-cents')||'0',10);
        const input = tr.querySelector('.qovg__qty');
        const q = input ? formatInt(input.value) : 0;
        return sum + price * q;
      }, 0);
    }

      // Read decoration per-piece upcharge (in cents) from GPO's
      // "Selections will add $X to the price" total line.
      // We then multiply by the Quick Order total quantity.
       // Read decoration per-piece upcharge (in cents) from GPO's
      // "Selections will add $X to the price" total line, but only
      // if at least one configured "decoration" property is active.
      function getDecorationEachCents(){
        const hidden = document.querySelector('.gpo-hidden-inputs');
        if (!hidden) return 0;

        // 1) Figure out which properties count as "decoration"
        //    from the section setting: data-deco-prop-names="decoration,Embroidery"
        const rawKeys = (root.dataset.decoPropNames || '').split(',');
        const decoKeys = rawKeys.map(s => s.trim().toLowerCase()).filter(Boolean);
        const hasConfig = decoKeys.length > 0;

        let isDecorated = false;

        if (hasConfig) {
          // Look at all hidden properties[...] inputs and check only the
          // names listed in decoKeys.
          const inputs = hidden.querySelectorAll('input[name^="properties["]');
          for (const input of inputs) {
            const name = input.name || '';
            const m = name.match(/^properties\[(.+)\]$/);
            if (!m) continue;

            const key = m[1].trim().toLowerCase();
            if (!decoKeys.includes(key)) continue; // not a decoration flag

            const val = (input.value || input.getAttribute('data-value') || '').trim().toLowerCase();
            if (val && val !== 'blank' && val !== 'none') {
              isDecorated = true;
              break;
            }
          }
        } else {
          // Fallback: legacy behavior for old setups
          const decoFlag = hidden.querySelector('input[name="properties[decoration]"]');
          const decoVal  = decoFlag && (decoFlag.value || decoFlag.getAttribute('data-value') || '');
          const norm     = (decoVal || '').trim().toLowerCase();
          isDecorated    = (norm === 'decorated');
        }

        if (!isDecorated) return 0;

        // 2) Read the "Selections will add $X" total from GPO
        const moneyEl = document.querySelector('.gpo-total .money, .gpo-total-text .money');
        if (!moneyEl) return 0;

        const txt   = (moneyEl.textContent || '').replace(/,/g, '');
        const match = txt.match(/([0-9]+(?:\.[0-9]+)?)/);
        if (!match) return 0;

        const val = parseFloat(match[1]);
        if (isNaN(val) || val <= 0) return 0;

        // $39.98 -> 3998 cents per piece
        return Math.round(val * 100);
      }

    function validateSteps(){
      const bad = [];
      getActiveInputs().forEach(i=>{
        const val = formatInt(i.value);
        if(val % STEP !== 0){ bad.push(`${i.dataset.group} ${i.dataset.label}: ${val}`); }
      });
      return bad;
    }

        function syncUI(){
      rowTotals();
      const gt = grandTotal();

      // Keep GPO's internal quantity in sync with our total
      try {
        const proxyQty = ensureProxyQuantityInput();
        if (proxyQty) {
          proxyQty.value = String(gt);
          pokeGPOQuantityEvents(proxyQty);
        }
      } catch (_e) {}

      // Write Quick Order total into a GPO Hidden Field (optional)
      gpoSetField('qo_total', gt);

      if (totalEl) totalEl.textContent = gt;
      if (totalItemsEl) totalItemsEl.textContent = gt;

      const stepIssues = validateSteps();
      const belowMin   = gt < MIN;

      // ----- Subtotals / discounts / per-row prices -----
      if (subtotalEl) {
        const subItemsRaw = computeSubtotalCents();      // garments only

        // Decoration: base per-piece value from GPO, then total for all pieces
        const decoEachBase = getDecorationEachCents();   // base deco per piece (no discounts)
        const decoRaw      = (gt > 0 && decoEachBase > 0) ? decoEachBase * gt : 0;

        const itemsTier = currentDiscount(gt);
        const decoTier  = currentDecoDiscount(gt);
        const effectiveDecoTier = ENABLE_DECO_DISCOUNT ? decoTier : null;

        let itemsDiscountCents = 0;
        let decoDiscountCents  = 0;

        // garments discount
        if (itemsTier && gt > 0) {
          if (itemsTier.type === 'percent') {
            itemsDiscountCents = Math.round(subItemsRaw * (itemsTier.value / 100));
          } else {
            const per = Math.round(itemsTier.value * 100);
            itemsDiscountCents = per * gt;
          }
        }

        // decoration discount (if enabled)
        if (effectiveDecoTier && gt > 0 && decoRaw > 0) {
          if (effectiveDecoTier.type === 'percent') {
            decoDiscountCents = Math.round(decoRaw * (effectiveDecoTier.value / 100));
          } else {
            const per = Math.round(effectiveDecoTier.value * 100);
            decoDiscountCents = per * gt;
          }
        }

        const subItems = Math.max(0, subItemsRaw - itemsDiscountCents);
        const deco     = Math.max(0, decoRaw - decoDiscountCents);

        const combinedRaw = subItemsRaw + decoRaw;
        const combined    = subItems + deco;

        // totals display (combined)
        if (combinedRaw !== combined && subtotalRawEl) {
          subtotalRawEl.style.display = '';
          subtotalRawEl.textContent = money(combinedRaw);
        } else if (subtotalRawEl) {
          subtotalRawEl.style.display = 'none';
          subtotalRawEl.textContent = money(combinedRaw);
        }
        subtotalEl.textContent = money(combined);

        // Garment line
        if (discountItemsEl) {
        if (SHOW_ITEM_DISCOUNTS && itemsDiscountCents > 0) {
          discountItemsEl.innerHTML =
            `<span class="qovg__money--muted"><s>${money(subItemsRaw)}</s></span> ${money(subItems)}`;
        } else {
          discountItemsEl.textContent = subItemsRaw > 0
            ? money(subItems)
            : '';
        }
      }

        // Decoration line
       if (discountDecoEl) {
  if (decoRaw <= 0) {
    discountDecoEl.textContent = '';
  } else if (SHOW_DECO_DISCOUNTS && decoDiscountCents > 0 && ENABLE_DECO_DISCOUNT) {
    discountDecoEl.innerHTML =
      `<span class="qovg__money--muted"><s>${money(decoRaw)}</s></span> ${money(deco)}`;
  } else {
    discountDecoEl.textContent = money(deco);
  }
}

        // update per-row "Price" cells to reflect deco + discounts
        const decoEachRaw = decoEachBase; // base per-piece deco

        getActiveRows().forEach(tr => {
          const baseCents = parseInt(tr.getAttribute('data-price-cents') || '0', 10);
          let garmentEach = baseCents;

          // Apply garment tier
          if (itemsTier) {
            if (itemsTier.type === 'percent') {
              garmentEach = Math.round(baseCents * (1 - itemsTier.value / 100));
            } else {
              const per = Math.round(itemsTier.value * 100);
              garmentEach = Math.max(0, baseCents - per);
            }
          }

          // Apply decoration tier (if enabled)
          let decoEach = decoEachRaw;
          if (effectiveDecoTier && decoEach > 0) {
            if (effectiveDecoTier.type === 'percent') {
              decoEach = Math.round(decoEach * (1 - effectiveDecoTier.value / 100));
            } else {
              const per = Math.round(effectiveDecoTier.value * 100);
              decoEach = Math.max(0, decoEach - per);
            }
          }

          const cell = tr.querySelector('[data-price-each]');
          if (!cell) return;

          const baseFullEach    = baseCents + (decoEachRaw || 0);   // garment + deco before discounts
          const combinedEach    = garmentEach + (decoEach || 0);    // garment + deco after discounts
          const hasAnyDiscounts = (itemsTier && SHOW_ITEM_DISCOUNTS) ||
                                  (decoEachRaw > 0 && effectiveDecoTier && SHOW_DECO_DISCOUNTS);

          if (hasAnyDiscounts && baseFullEach !== combinedEach) {
            cell.innerHTML =
              `<span class="qovg__money--muted"><s>${money(baseFullEach)}</s></span><br>` +
              `<span class="qovg__money">${money(combinedEach)}</span>`;
          } else if (decoEachRaw > 0 || decoEach > 0) {
            // No visual discounts, but still show garment+deco combined
            cell.textContent = money(combinedEach);
          } else {
            // Plain garment only
            cell.textContent = money(baseCents);
          }
        });
      }

      // ----- Validation + button states -----
      if (stepIssues.length) {
        errorEl.style.display = '';
        errorEl.textContent = `Quantities must be in multiples of ${STEP}. Check: ${stepIssues.join(', ')}`;
      } else if (belowMin) {
        const pre = root.getAttribute('data-min-prefix') || 'Select at least';
        const suf = root.getAttribute('data-min-suffix') || 'total. Currently';
        errorEl.style.display = '';
        errorEl.textContent = `${pre} ${MIN} ${suf} ${gt}.`;
      } else {
        errorEl.style.display = 'none';
        errorEl.textContent = '';
      }

      addBtn.disabled = !!stepIssues.length || belowMin || gt === 0;
      if (buyNowBtn) {
        buyNowBtn.disabled = addBtn.disabled;
      }
    }


    // ---------- Counter buttons ----------
    Array.from(root.querySelectorAll('.qovg__counter')).forEach(c => {
      const minus = c.querySelector('.qovg__minus');
      const plus  = c.querySelector('.qovg__plus');
      const input = c.querySelector('.qovg__qty');
      const localStep = parseInt(c.dataset.step || input.step || STEP, 10) || STEP;

      const snap = v => {
        v = Math.max(0, parseInt(v || '0', 10) || 0);
        if (v % localStep !== 0) v = Math.round(v / localStep) * localStep;
        return v;
      };

      minus?.addEventListener('click', () => {
        if (input.disabled) return;
        const v = snap((parseInt(input.value || '0',10) || 0) - localStep);
        input.value = Math.max(0, v);
        input.dispatchEvent(new Event('change', { bubbles:true }));
        input.dispatchEvent(new Event('input',  { bubbles:true }));
      });

      plus?.addEventListener('click', () => {
        if (input.disabled) return;
        const v = snap((parseInt(input.value || '0',10) || 0) + localStep);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles:true }));
        input.dispatchEvent(new Event('input',  { bubbles:true }));
      });
    });

    // ---------- Input listeners ----------
    allQtyInputs.forEach(i=>{
      i.addEventListener('change', ()=>{
        let v = formatInt(i.value);
        if(v % STEP !== 0){ v = Math.round(v / STEP) * STEP; i.value = v; }
        syncUI();
      });
      i.addEventListener('input', syncUI);
    });

    // ---------- Initial sync ----------
    syncUI();

    
     // ---------- Swatch Filter UI ----------
    const swatchWrap = root.querySelector('#qovg-swatches');
    if (swatchWrap) {
      const cards    = [...root.querySelectorAll('.qovg__card')];
      const swatches = [...swatchWrap.querySelectorAll('.qovg__swatch')];
      const swatchCount = swatches.length;
      let dropdownToggle = null;
      let prefillN = 0;

      // If there are lots of colours, collapse swatches behind a toggle button
      if (swatchCount > 5) {
        swatchWrap.classList.add('qovg__swatches--dropdown');

        dropdownToggle = document.createElement('button');
        dropdownToggle.type = 'button';
        dropdownToggle.className = 'qovg__swatch-dropdown-toggle';
        dropdownToggle.setAttribute('aria-expanded', 'false');
        dropdownToggle.innerHTML =
          '<span class="qovg__swatch-dropdown-label">Select colours</span>' +
          '<span class="qovg__swatch-dropdown-icon">▾</span>';

        // Insert the toggle just before the swatch grid
        swatchWrap.parentNode.insertBefore(dropdownToggle, swatchWrap);
      }

      // start hidden
      cards.forEach(c => { c.classList.add('is-hidden'); c.style.display = 'none'; });

      // remember prefill setting; we’ll use it later if no variant match
      try {
        prefillN = parseInt(root.getAttribute('data-prefill') || '0', 10) || 0;
      } catch (e) {}
     

      const zeroCard = (card) => {
        const inputs = card.querySelectorAll('.qovg__qty');
        inputs.forEach(inp => {
          if ((parseInt(inp.value || '0', 10) || 0) !== 0) {
            inp.value = 0;
            inp.dispatchEvent(new Event('change', { bubbles: true }));
            inp.dispatchEvent(new Event('input',  { bubbles: true }));
          }
        });
        const pill = card.querySelector('[data-row-total]');
        if (pill) pill.textContent = '0';
      };

      const apply = () => {
        const chosen = new Set(
          swatches.filter(b => b.classList.contains('is-selected'))
                  .map(b => b.getAttribute('data-group'))
        );

        if (chosen.size === 0) {
          cards.forEach(c => {
            zeroCard(c);
            c.classList.add('is-hidden');
            c.style.display = 'none';
          });
          return;
        }

        cards.forEach(c => {
          const val = c.getAttribute('data-group');
          if (chosen.has(val)) {
            c.classList.remove('is-hidden');
            c.style.display = '';
          } else {
            zeroCard(c);
            c.classList.add('is-hidden');
            c.style.display = 'none';
          }
        });
      };

      const updateToggleLabel = () => {
        if (!dropdownToggle) return;
        const labelSpan = dropdownToggle.querySelector('.qovg__swatch-dropdown-label');
        if (!labelSpan) return;

        const active = swatches.filter(b => b.classList.contains('is-selected'));
        labelSpan.innerHTML = '';

        if (!active.length) {
          labelSpan.textContent = 'Select colours';
          return;
        }

        const chipsWrap = document.createElement('div');
        chipsWrap.className = 'qovg__swatch-dropdown-chips';

        const maxChips = 15;
        active.slice(0, maxChips).forEach(sw => {
          const chip = sw.cloneNode(true);
          chip.classList.add('qovg__swatch-chip');
          chip.removeAttribute('aria-pressed');
          chip.removeAttribute('tabindex');
          chip.style.pointerEvents = 'none';
          chipsWrap.appendChild(chip);
        });

        labelSpan.appendChild(chipsWrap);

        const names = active.map(sw =>
          sw.getAttribute('data-group') ||
          sw.getAttribute('data-label') ||
          sw.textContent.trim()
        ).filter(Boolean);

        const namesEl = document.createElement('div');
        namesEl.className = 'qovg__swatch-dropdown-names';

        if (active.length <= maxChips) {
          namesEl.textContent = names.join(', ');
        } else {
          const shown = names.slice(0, maxChips).join(', ');
          const extra = active.length - maxChips;
          namesEl.textContent = `${shown} + ${extra} more`;
        }

        labelSpan.appendChild(namesEl);
      };
      function clearSwatchSelection() {
        swatches.forEach(b => {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
      }

      function selectGroupsByValue(groups) {
        const set = new Set((groups || []).filter(Boolean));
        if (!set.size) return;
        clearSwatchSelection();
        swatches.forEach(btn => {
          const g = btn.getAttribute('data-group');
          if (set.has(g)) {
            btn.classList.add('is-selected');
            btn.setAttribute('aria-pressed', 'true');
          }
        });
        apply();
        syncUI();
        updateToggleLabel();
      }

      // Keep the Quick Order colour selection in sync with the main product variant
      function syncSwatchesToMainVariant(useFallback = true) {
        const activeVariantId  = getActiveVariantIdFromMainForm();
        const activeGroupValue = getGroupValueForVariant(root, activeVariantId);

        if (activeGroupValue) {
          selectGroupsByValue([activeGroupValue]);
          return;
        }

        // fallback: preselect first N swatches if configured
        if (useFallback && prefillN > 0) {
          clearSwatchSelection();
          swatches.slice(0, prefillN).forEach(btn => {
            btn.classList.add('is-selected');
            btn.setAttribute('aria-pressed', 'true');
          });
          apply();
          syncUI();
          updateToggleLabel();
        }
      }
      swatches.forEach(btn => {
        btn.addEventListener('click', () => {
          btn.classList.toggle('is-selected');
          btn.setAttribute('aria-pressed', btn.classList.contains('is-selected'));
          apply();
          syncUI();
          updateToggleLabel();
        });
      });

      // Initial sync: match the currently selected variant,
      // falling back to prefill behaviour if needed.
      syncSwatchesToMainVariant(true);

      // Whenever the main product variant changes, keep the Quick Order swatches in sync
      const productForm = getProductForm();
      if (productForm && !productForm._qovgVariantBound) {
        productForm._qovgVariantBound = true;
        productForm.addEventListener('change', (evt) => {
          const t = evt.target;
          if (!t) return;

          if (
            t.matches('select[name="id"]') ||
            t.matches('input[name="id"]')
          ) {
            // Variant changed (theme usually also updates URL here)
            syncSwatchesToMainVariant(false); // no need to re-run prefill fallback
          }
        });
      }

      if (dropdownToggle) {
        dropdownToggle.addEventListener('click', () => {
          const open = swatchWrap.classList.toggle('is-open');
          dropdownToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      
    }
    // Mount Globo widget beside grid after it renders
    waitAndMountGPO();
    attachGpoListeners(root);

    // ---------- Properties & Cart ----------
    function collectGPOProperties() {
      const gpoRoot = document.querySelector('.gpo-hidden-inputs');
      const props = {};
      if (!gpoRoot) return props;

      // 1) Base mirror (exactly what GPO would send)
      gpoRoot.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach(el => {
        if (el.disabled) return;
        const name = el.getAttribute('name');               // e.g. properties[deco]
        if (!name) return;
        const key  = name.slice('properties['.length, -1);  // -> deco
        const val  = el.value ?? el.getAttribute('data-value') ?? '';
        if (String(val).trim() === '' && !el.hasAttribute('data-value')) return;
        props[key] = val;
      });

      // 2) Multi-select groups like properties[decoration-6][]
      const multi = new Set();
      document.querySelectorAll('[data-name^="properties["][data-field-name]').forEach(el => {
        const dn = el.getAttribute('data-name'); // e.g. properties[decoration-6][]
        const m  = dn && dn.match(/^properties\[(.+?)\]\[\]$/);
        if (m) multi.add(m[1]); // decoration-6
      });

      multi.forEach(field => {
        const selected = [];
        document.querySelectorAll(`[data-name="properties[${CSS.escape(field)}][]"]`).forEach(el => {
          const isChecked = (el.tagName === 'INPUT')
            ? ((el.type === 'checkbox' || el.type === 'radio') ? el.checked : true)
            : (el.tagName === 'OPTION' ? el.selected : true);
          if (!isChecked) return;
          const v = el.value ?? el.getAttribute('data-value') ?? '';
          if (String(v).trim() !== '') selected.push(v);
        });
        if (selected.length) props[field] = (selected.length === 1) ? selected[0] : selected;
        else delete props[field];
      });

      // 3) Your helper flag (optional)
      const decos = props['decoration-6'];
      const hasDeco = Array.isArray(decos) ? decos.length > 0 : !!decos;
      props['deco'] = hasDeco ? 'Decorated' : (props['deco'] || 'Blank');

      return props;
    }

    async function addToCart(items){
      const url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js';
      const res = await fetch(url, {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items })
      });
      if(!res.ok){ throw await res.json().catch(()=>({message:'Add to cart failed'})); }
      return res.json();
    }

    // prevent accidental form submit interference
    try {
      addBtn.addEventListener('click', (e)=> e.preventDefault(), { capture:true });
    } catch(e){}

    async function handleAddToCart(modeOverride, triggerBtn){
      syncUI();
      if (addBtn.disabled) return;

      const props = collectGPOProperties();

      const chosen = getActiveInputs()
        .map(i=>({ id: parseInt(i.dataset.variantId,10), qty: formatInt(i.value) }))
        .filter(x=> x.qty > 0);

      let items = chosen.map(x => ({ id: x.id, quantity: x.qty, properties: props }));

      // Add GPO add-on variants selected in the widget
      const addons = collectGPOAddonVariants();
      if (addons.length) {
        // (A) quantities summed across all lines (one add-on line total)
        const totalQty = chosen.reduce((n, x) => n + x.qty, 0);
        addons.forEach(a => items.push({ id: a.id, quantity: a.quantity * totalQty }));

        // Other strategies (per-line, as-selected) can be swapped in later if needed
      }

      const spinnerTpl = root.querySelector('#qovg-spinner');
      const label = triggerBtn.textContent;
      triggerBtn.disabled = true;
      triggerBtn.innerHTML = spinnerTpl ? spinnerTpl.innerHTML + '<span>Adding…</span>' : 'Adding…';

      try{
        await addToCart(items);

        const defaultMode = (root.getAttribute('data-after-add') || 'drawer_or_cart');
        const mode = modeOverride || defaultMode; // 'cart' | 'drawer_or_cart' | 'none' | 'checkout'

        if (mode === "checkout"){
          window.location.href = ((window.Shopify && Shopify.routes) ? Shopify.routes.root : '/') + 'checkout';
          return;
        }

        if (mode === "cart"){
          window.location.href = ((window.Shopify && Shopify.routes) ? Shopify.routes.root : '/') + 'cart';
          return;
        }

        if (mode === "drawer_or_cart"){
          let opened = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          const toggles = document.querySelectorAll('[data-cart-drawer-toggle],[data-cart-toggle],.js-open-cart,button[name="open-drawer"][value="cart"]');
          if(toggles.length){ toggles[0].click?.(); opened = true; }
          setTimeout(()=>{ if(!opened) window.location.href = ((window.Shopify && Shopify.routes) ? Shopify.routes.root : '/') + 'cart'; }, 200);
        } else {
          triggerBtn.innerHTML = 'Added! View cart';
        }
      }catch(err){
        console.error(err);
        errorEl.style.display='';
        errorEl.textContent = (err && err.message) ? err.message : 'Could not add to cart.';
        triggerBtn.innerHTML = label;
        triggerBtn.disabled = false;
      }
    }

    // Primary button: use configured after_add_action
    addBtn.addEventListener('click', (e)=>{
      e.preventDefault();
      handleAddToCart(null, addBtn);
    });

    // Buy Now: always go to checkout
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        handleAddToCart('checkout', buyNowBtn);
      });
    }
        // ---------- React to GPO changes ----------
    function attachGpoListeners(root) {
      // avoid double-binding for this qovg instance
      if (root._qovgGpoAttached) return;
      root._qovgGpoAttached = true;

      const debouncedSync = () => {
        clearTimeout(root._qovgSyncTimer);
        root._qovgSyncTimer = setTimeout(() => {
          // console.log('[qovg] syncUI from GPO');
          syncUI();
        }, 40);
      };

      function tryAttach() {
        const gpoHidden = document.querySelector('.gpo-hidden-inputs');
        const gpoTotal  = document.querySelector('.gpo-total, .gpo-total-text');

        // If GPO hasn't rendered yet, try again shortly
        if (!gpoHidden && !gpoTotal) {
          setTimeout(tryAttach, 200);
          return;
        }

        // 1) Hidden inputs container – properties and flags
        if (gpoHidden && !gpoHidden._qovgBound) {
          gpoHidden._qovgBound = true;

          ['change','input','keyup'].forEach(evt => {
            gpoHidden.addEventListener(evt, debouncedSync, true);
          });

          const moHidden = new MutationObserver(debouncedSync);
          moHidden.observe(gpoHidden, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true
          });
        }

        // 2) “Selections will add $X” total line
        if (gpoTotal && !gpoTotal._qovgBound) {
          gpoTotal._qovgBound = true;

          const moTotal = new MutationObserver(debouncedSync);
          moTotal.observe(gpoTotal, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true
          });
        }
      }

      tryAttach();
    }




  }

  // ---------- Boot ----------
  function boot(){
    document.querySelectorAll('.qovg').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
